import React from "react";
import { useLocation } from "react-router-dom";

import { hasAnalyticsConsent } from "../cookies/CookieConsent";

import { syncGoogleAnalytics } from "../../analytics/ga4";

/* =========================================================
   GOOGLE ANALYTICS
   ========================================================= */

export default function GoogleAnalytics() {
  const { pathname } = useLocation();

  /* -------------------------------------------------------
     INITIAL CONSENT FROM EXISTING COOKIE
     ------------------------------------------------------- */

  const [analyticsAllowed, setAnalyticsAllowed] = React.useState(() =>
    hasAnalyticsConsent(),
  );

  /* -------------------------------------------------------
     LISTEN FOR COOKIE PREFERENCE CHANGES
     ------------------------------------------------------- */

  React.useEffect(() => {
    const handleConsentChanged = () => {
      setAnalyticsAllowed(hasAnalyticsConsent());
    };

    window.addEventListener(
      "legup-cookie-consent-changed",
      handleConsentChanged,
    );

    // Restore the latest saved preference.
    handleConsentChanged();

    return () => {
      window.removeEventListener(
        "legup-cookie-consent-changed",
        handleConsentChanged,
      );
    };
  }, []);

  /* -------------------------------------------------------
     TRACK APPROVED PUBLIC ROUTES
     ------------------------------------------------------- */

  React.useEffect(() => {
    syncGoogleAnalytics(pathname, analyticsAllowed);
  }, [pathname, analyticsAllowed]);

  return null;
}
